
export const DEPARTMENTS = {
  CLINICAL: {
    category: 'Clinical/Medical Departments',
    departments: [
      { id: '1', name: 'Medical records', description: 'Maintaining patient medical records'},
      { id: '2', name: 'Emergency (ER/A&E)', description: 'Handles urgent and life-threatening conditions' },
      { id: '3', name: 'General Medical Services', description: 'Out-Patient ,Diagnosis and non-surgical treatment of adults/Pediatrics'},
      { id: '4', name: 'Surgery/Theatre', description: 'Surgical procedures (major & minor)' },
      { id: '5', name: 'Wards & Nursing Services', description: 'Care for admitted patients including monitoring, medication administration, and nursing care' },
      { id: '6', name: 'Obstetrics & Gynecology (OB-GYN)', description: 'Pregnancy, childbirth, women\'s reproductive health' },
      { id: '8', name: 'Cardiology', description: 'Heart-related care' },
      { id: '9', name: 'Neurology', description: 'Brain and nervous system' },
      { id: '10', name: 'Orthopedics', description: 'Bones, joints, and muscles' },
      { id: '11', name: 'Urology', description: 'Urinary system and male reproductive organs' },
      { id: '12', name: 'Dermatology', description: 'Skin-related issues' },
      { id: '13', name: 'Oncology', description: 'Cancer diagnosis and treatment' },
      { id: '14', name: 'Nephrology', description: 'Kidney care and dialysis' },
      { id: '15', name: 'Psychiatry', description: 'Mental health services' },
      { id: '16', name: 'Radiology', description: 'Imaging: X-rays, MRI, CT scans' },
      { id: '17', name: 'Investigations', description: 'Diagnostic lab tests, blood work, biopsies ,Scan' }
    ]
  },

  DIAGNOSTIC: {
    category: 'Diagnostic & Support Departments',
    departments: [
      { id: '18', name: 'Pharmacy', description: 'Dispenses medications, manages drug stock' },
      { id: '19', name: 'Laboratory', description: 'Conducts blood tests, urine tests, etc.' },
      { id: '20', name: 'Radiology', description: 'Imaging diagnostics (X-ray, CT, ultrasound)' },
      { id: '21', name: 'Physiotherapy', description: 'Rehabilitation and therapy services' },
      { id: '22', name: 'Dietary/Nutrition', description: 'Manages patient diet plans and food services' },
      { id: '23', name: 'Biomedical Engineering', description: 'Maintains medical devices and equipment' }
    ]
  },
  ADMINISTRATIVE: {
    category: 'Administrative Departments',
    departments: [
      { id: '24', name: 'Health Information', description: 'Data about your health status, conditions, treatments, and demographics' },
      { id: '25', name: 'Billing & Accounts', description: 'Handles billing, invoicing, payments' },
      { id: '26', name: 'Human Resources (HR)', description: 'Manages hospital staff and roles' },
      { id: '27', name: 'IT / ICT Department', description: 'Handles technical infrastructure, HMS, etc.' },
      { id: '28', name: 'Procurement & Supplies', description: 'Orders and tracks equipment, drugs' },
      { id: '29', name: 'Maintenance', description: 'Facility repair, equipment upkeep' },
      { id: '30', name: 'Hospital Claims', description: 'Manages hospital insurance claims and billing reconciliations' }
    ]
  },
  SPECIALTY: {
    category: 'Specialty Clinics',
    departments: [
      { id: '31', name: 'Diabetic Clinic', description: 'Specialized diabetes care and management' },
      { id: '32', name: 'HIV/AIDS Care Unit', description: 'Comprehensive HIV/AIDS treatment and support' },
      { id: '33', name: 'Antenatal Clinic (ANC)', description: 'Prenatal care and pregnancy monitoring' },
      { id: '34', name: 'Eye Clinic (Ophthalmology)', description: 'Eye care and vision services' },
      { id: '35', name: 'ENT Clinic (Ear, Nose, Throat)', description: 'Ear, nose, and throat treatments' },
      { id: '36', name: 'Tuberculosis (TB) Unit', description: 'TB diagnosis, treatment, and prevention' }
    ]
  }
};


export  const categorie = {
      'Clinical/Medical Departments': ['1','2', '3', '4', '5', '6', '7','8','9','10', '11', '12', '13', '14', '15','16','17'],
      'Specialty Clinics': ['31', '32', '33', '34', '35', '36'], 
      'Diagnostic & Support Departments': ['18', '19','20','21','22','23'],
      'Administrative Departments': ['24','25','26','27','28','29','30'], 
};
    




export const getAllDepartments = () => {
  return Object.values(DEPARTMENTS).flatMap(category => category.departments);
};


export const getDepartmentById = (id) => {
  return getAllDepartments().find(dept => dept.id === id);
};
